import React, { memo } from 'react';

export interface TabularHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const TabularHeader = memo(function TabularHeader({
  title,
  subtitle,
  actions,
  className = ''
}: TabularHeaderProps) {
  return (
    <div className={`tabular-header ${className}`}>
      <div className="tabular-header-content">
        <h1 className="tabular-header-title">{title}</h1>
        {subtitle && (
          <p className="tabular-header-subtitle">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="tabular-header-actions">
          {actions}
        </div>
      )}
    </div>
  );
});
